import {BaseObject} from './BaseObject';
import {File} from './File';

export class Payment extends BaseObject {
    id: number;
    file: File = new File();

    setFileContent = (data: string, filename: string) => {
        this.file.name = filename;
        this.file.base64 = data;
    }
}




// WEBPACK FOOTER //
// /app/src/model/Entities/Payment.ts